import {
  compose, lifecycle, withHandlers, getContext,
} from 'recompose';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router';
import TimeEntryHistory from './timeEntryHistory';
import { taskActions, taskSelectors } from '../../../../../state/task';
import { preloaderWhileLoading } from '../../../../../utils/enchancers';
import { PRELOADER_DIMENSION } from '../../../../../constants/ui';
import { uiActions } from '../../../../../state/ui';

const mapDispatchToProps = {
  getTimeEntries: taskActions.getTimeEntriesRequest,
  setOpenModal: uiActions.openModal,
};

const mapStateToProps = state => ({
  timeEntriesList: taskSelectors.getTimeEntriesList(state),
  isPending: taskSelectors.getTimeEntriesRequestPending(state),
});

const onEditHandler = ({ setOpenModal, setSelectedTimeEntryId }) => (id) => {
  setOpenModal('editTimeEntry');
  setSelectedTimeEntryId(id);
};

const onDeleteHandler = ({ setOpenModal, setSelectedTimeEntryId }) => (id) => {
  setOpenModal('deleteTimeEntry');
  setSelectedTimeEntryId(id);
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation(['tasks']),
  withRouter,
  getContext({
    setSelectedTimeEntryId: PropTypes.func.isRequired,
    clientId: PropTypes.string,
  }),
  withHandlers({
    onDelete: onDeleteHandler,
    onEdit: onEditHandler,
  }),
  lifecycle({
    componentDidMount() {
      const { getTimeEntries, clientId, match: { params: { id, taskId } } } = this.props;
      getTimeEntries({ projectId: id, taskId, clientId });
    },
  }),
  preloaderWhileLoading({
    dimension: PRELOADER_DIMENSION.SMALL,
    alignContainerCenter: false,
    delay: 600,
    isLoading: () => false,
    onAction: ({ isPending }) => isPending,
  }),
);
export default enhance(TimeEntryHistory);
